import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { signIn, signOut, getCurrentUser, fetchAuthSession } from '@aws-amplify/auth';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  constructor() {
    // Configure Amplify
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: environment.COGNITO_USER_POOL_ID,
          userPoolClientId: environment.COGNITO_CLIENT_ID
        }
      }
    });
  }

  /**
   * Get current authenticated user's JWT token
   */
  async getCurrentUserToken(): Promise<string> {
    try {
      const session = await fetchAuthSession();
      return session.tokens.idToken.toString();
    } catch (error) {
      throw new Error('No authenticated user found');
    }
  }

  /**
   * Check if user is authenticated
   */
  async isAuthenticated(): Promise<boolean> {
    try {
      await getCurrentUser();
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Get current user
   */
  async getCurrentUser() {
    try {
      return await getCurrentUser();
    } catch (error) {
      throw new Error('No authenticated user found');
    }
  }

  /**
   * Sign out user
   */
  async signOut() {
    try {
      await signOut();
    } catch (error) {
      throw error;
    }
  }

  /**
   * Manually set user session after confirmation
   */
  async setUserSession(username: string, password: string): Promise<void> {
    try {
      // Sign in the user to establish a session
      await signIn({ username, password });
      
    } catch (error) {
      
      throw error;
    }
  }
}
